
import SortPicker from '../components/sort-picker.vue';
import PickLandlord from '../owner/widgets/pick-landlord.vue';

export default {
    name: 'room',
    components: {
        'sort-picker': SortPicker,
        'pick-landlord': PickLandlord
    },
    props: {
        room: {
            type: Object,
            required: false
        },
    },
    created() {

        let t = this;

        t.dict.room = listToDict(t.list.room);

        t.dict.lock = listToDict(t.list.lock);

        t.loadData();

    },
    activated() {

        let t = this;

    },
    methods: {

        init() {

            let t = this;

            if (t.room) {
                mirror2(t.room, t.f);
                if (t.f.lock_id) {
                    t.f.lock_id = Number(t.f.lock_id);
                }
                t.room.clean_areas.forEach(item => {
                    t.f2[item.area_id] = item.quantity;
                });

                debug(() => {
                    if (t.room) {
                        t.view = 'tags';
                    }
                });

                let tagIds = [];
                if (t.room && t.room.tag_mapping.length > 0) {
                    tagIds = t.room.tag_mapping.map(item => item.tag_id);
                }
                t.list.tag.forEach(item => {
                    item.selected = false;
                    if (tagIds.indexOf(item.id) > -1)
                        item.selected = true;
                });
            }

                t.$forceUpdate();
                t.loadOwnerBinding();
        },

        loadData() {

            let t = this;

            axios.get('cleanArea').then(res => {
                if (res.data.status == 1) {
                    t.list.cleanArea = res.data.options.items;

                    t.list.cleanArea.forEach(item => {
                        t.f2[item.id] = 0;
                    });

                    t.init();

                }
            });

            axios.get('getUnusedRoomsAndLocks').then(res => {
                if (res.data.status == 1) {
                    t.list.lock = res.data.options.locks.filter(item => item.used == 0);
                    t.dict.lock = listToDict(res.data.options.locks);
                    t.list.room = res.data.options.rooms;
                    t.dict.room = listToDict(t.list.room);
                    if (!t.f.id && t.list.room.length > 0) {
                        if (t.list.room.length == 1) {
                            t.f.outside_id = t.list.room[0].id;
                        }
                        else {
                            t.showRoomPicker = true;
                        }
                    }
                    t.$forceUpdate();
                }
            });

            axios.get('roomTag').then(res => {
                if (res.data.status == 1) {
                    let items = res.data.options.items;
                    items.forEach(item => {
                        item.selected = false;
                    });
                    t.list.tag = items;
                    t.dict.tag = listToDict(t.list.tag);

                }
            });

        },

        onSubmitInfo() {

            let t = this;

            if (t.busying)
                return;

            t.busying = true;

            let isNew = !t.f.id;

            if (t.f.smart_lock == 1)
                t.f.static_password = 'AUTO';

            axios.post('room/saveInfo', t.f).then(res => {

                t.busying = false;

                if (res.data.status == 1) {
                    A.toast('Saved.');
                    t.f.id = res.data.options.item.id;
                    if (isNew)
                        t.setView('clean_area');
                    mirror(t.f, t.room);
                }
                else {
                    A.err('Faild.');
                }
            });

        },

        onSubmitCleanArea() {

            let t = this;

            if (t.busying)
                return;

            t.busying = true;

            let data = {
                'id': t.f.id,
                'json': JSON.stringify(t.f2)
            }

            axios.post('room/saveCleanAreas', data).then(res => {

                t.busying = false;

                if (res.data.status == 1) {
                    A.toast('Saved.');
                }
                else {
                    A.err('Faild.');
                }
            });

        },

        loadOwnerBinding() {
            let t = this;
            t.ownerName = '';
            t.currentLandlordId = null;
            t.ownerHistory = [];
            t.contractEnd = '';
            if (!t.f.id) return;
            axios.get('room/landlordHistory', { params: { room_id: t.f.id } }).then(res => {
                if (res.data.status != 1) return;
                t.ownerHistory = (res.data.options && res.data.options.items) || [];
                t.applyOwnerContract(t.ownerHistory);
            });
            axios.get('room/' + t.f.id, { params: { _with: 'landlord' } }).then(res => {
                if (res.data.status != 1) return;
                let room = res.data.options && res.data.options.item;
                if (!room) return;
                t.fillOwnerName(room);
            });
        },
        applyOwnerContract(rows) {
            rows = rows || [];
            let open = null;
            for (let i = 0; i < rows.length; i++) {
                if (!rows[i].effective_to && rows[i].landlord_id) {
                    open = rows[i];
                    break;
                }
            }
            let row = open || rows[0] || null;
            this.contractEnd = row && row.contract_end ? String(row.contract_end).slice(0, 10) : '';
        },
        fillOwnerName(room) {
            let t = this;
            if (!room.landlord_id) {
                t.currentLandlordId = null;
                t.ownerName = '所有者なし';
                return;
            }
            t.currentLandlordId = room.landlord_id;
            let related = room.landlord;
            if (related && (related.name || related.lastname || related.firstname)) {
                t.ownerName = related.name || ((related.lastname || '') + (related.firstname || ''));
                return;
            }
            axios.get('landlord/' + room.landlord_id).then(res => {
                if (res.data.status != 1) return;
                let item = res.data.options && res.data.options.item;
                if (!item) return;
                t.ownerName = item.name || ((item.lastname || '') + (item.firstname || ''));
            });
        },
        formatHistoryRow(row) {
            let from = row.effective_from || '';
            let to = row.effective_to ? row.effective_to : '現在';
            let name = row.landlord_name || '所有者なし';
            return from + ' ～ ' + to + '　' + name;
        },
        openOwnerPick() {
            if (!this.f.id) {
                A.toast('宿情報を更新してから、オーナーを設定できます。');
                return;
            }
            this.ownerPick = true;
        },
        onOwnerAssigned(payload) {
            if (payload && payload.item) this.fillOwnerName(payload.item);
            this.loadOwnerBinding();
        },
        saveContractEnd() {
            let t = this;
            if (!t.f.id || t.contractBusy) return;
            t.contractBusy = true;
            axios.post('room/setContractEnd', {
                room_id: Number(t.f.id),
                contract_end: t.contractEnd || ''
            }).then(res => {
                t.contractBusy = false;
                if (res.data.status != 1) {
                    A.toast('保存に失敗しました');
                    return;
                }
                let opt = res.data.options || {};
                if (opt.history) {
                    t.ownerHistory = opt.history;
                    t.applyOwnerContract(opt.history);
                }
                if (opt.item) t.fillOwnerName(opt.item);
                A.toast('保存しました');
            }).catch(() => {
                t.contractBusy = false;
                A.toast('通信に失敗しました');
            });
        },
        addFromAirhost() {
            this.$emit('add-airhost');
        },
        focusLock() {
            let field = this.$refs.lockField;
            let el = field && field.$el ? field.$el : field;
            if (el && el.scrollIntoView) el.scrollIntoView({ block: 'center' });
            if (el && el.focus) el.focus();
        },
        goRoomSettlement() {
            if (!this.currentLandlordId) {
                A.toast('オーナーが未設定です');
                return;
            }
            this.$router.push({
                path: '/pl_landlord_settlement',
                query: {
                    landlord_id: this.currentLandlordId,
                    room_id: Number(this.f.id)
                }
            });
        },
        onConfirmLock(inst, lock) {
            console.log(lock);

            this.f.lock_id = lock.id;
            this.f.admin_password = lock.password;
        },

        onConfirmRoom(inst, room) {
            this.f.outside_id = room.id;
            this.showRoomPicker = false;
            if (!this.f.name)
                this.f.name = room.name;
        },

        setView(v) {
            if (v == 'clean_area') {
                if (!this.f.id) {
                    A.err('宿情報を更新してから、清掃情報を入力することができます。');
                    return;
                }
            }
            this.view = v;
        },

        selectTag(item) {
            item.selected = !item.selected;
        },

        saveTag() {
            let t = this;
            let f = t.tagForm;

            if (!f.name) {
                t.addingTag = false;
                return;
            }

            axios.post('roomTag', f).then(res => {
                if (res.data.status == 1) {
                    let tag = res.data.options;
                    t.addingTag = false;
                    tag.selected = false;
                    t.list.tag.push(tag);
                    t.dict.tag[tag.id] = tag;
                }
            });

        },

        saveRoomTags() {

            let t = this;

            let form = {
                tag_ids: t.selectedTags.map(item => item.id),
                room_id: t.room.id
            };

            if (t.busying)
                return;

            t.busying = true;

            axios.post('roomTag/saveRoomMapping', form).then(res => {

                t.busying = false;

                if (res.data.status == 1) {
                    t.room.tag_mapping = res.data.options.tag_mapping;
                    A.toast('Saved.');
                }
            });


        },

        removeTag(item) {
            let t = this;
            axios.delete('roomTag/' + item.id).then(res => {
                if (res.data.status == 1) {
                    t.list.tag.remove(item);
                    delete t.dict.tag[item.id];
                }
            });

        },

    },
    data() {
        return {
            addingTag: false,
            ownerPick: false,
            ownerName: '',
            currentLandlordId: null,
            ownerHistory: [],
            contractEnd: '',
            contractBusy: false,
            showLockPicker: false,
            showRoomPicker: false,
            view: 'info',
            dict: {
                room: {},
                lock: {},
                tag: {}
            },
            list: {
                type: [
                    { id: 'A', name: 'A' },
                    { id: 'B', name: 'B' },
                    { id: 'C', name: 'C' },
                    { id: 'D', name: 'D' },
                    { id: 'E1', name: 'E1' },
                    { id: 'E2', name: 'E2' },
                    { id: 'F1', name: 'F1' },
                    { id: 'F2', name: 'F2' },
                ],
                room: [
                ],
                lock: [
                ],
                cleanArea: [],
                tag: [],
            },
            f: {
                id: 0,
                name: '',
                name_en: '',
                outside_id: '',
                lock_id: '',
                max_s: '',
                max_k: '',
                max_q: '',
                max_d: '',
                lock_type: 1,
                type: 'A',
                frontend: '',
                address: '',
                admin_password: '',
                case_password: '',
                static_password: '',
                smart_lock: 1,
                google_map_url: '',
                frontend_type: 1,
                google_map_url_building: '',
            },
            f2: {

            },
            tagForm: {
                name: ''
            },
            keywordSearch: {
                tag_name: ''
            }
        };
    },
    computed: {
        filteredTags() {
            let t = this;

            let arr = [];

            t.list.tag.forEach(item => {
                if (t.keywordSearch.tag_name && (item.name.indexOf(t.keywordSearch.tag_name) > -1)) {
                    arr.push(item);
                }
            });

            return arr;
        },

        selectedTags() {
            let t = this;

            let arr = [];

            t.list.tag.forEach(item => {
                if (item.selected) {
                    arr.push(item);
                }
            });

            return arr;
        },
    }
};
